module.exports = __webpack_public_path__ + "static/img/detail-friendW.93e26c64.png";